import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
export const CHECKOUT_URL = 'https://mtc-arg.impultienda.ar';
export const SUPPORT_EMAIL = 'soportelumenakasha@gmail.com';
export const WHATSAPP_LABEL = '+54 11 5339-9780';
export const WHATSAPP_URL = 'https://wa.me/5491153399780';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  /** Kept for API compatibility; the design system uses flat surfaces, so no glow is rendered. */
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = ''
}: SectionProps) {
  const reduceMotion = useReducedMotion();
  return <motion.section id={id} initial={reduceMotion ? false : {
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-219" data-mp="ke02480hbjva">
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'purple'
}: CTAButtonProps) {
  const reduceMotion = useReducedMotion();
  const colorClass = variant === 'purple' ? 'bg-red-700 hover:bg-red-800' : 'bg-amber-700 hover:bg-amber-800';
  return <motion.a href={href} whileTap={reduceMotion ? undefined : {
    scale: 0.98
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`relative inline-flex items-center justify-center rounded-lg px-8 py-4 text-center text-base font-semibold tracking-wide text-white shadow-md transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-stone-900 ${colorClass} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-220" data-mp="2luotfkb7lyct">
      <span className="relative z-10" data-id="element-221" data-mp="1t7fbineyfrdg">{children}</span>
    </motion.a>;
}
type SectionHeadingProps = {
  children: React.ReactNode;
  character?: string;
  className?: string;
};
export function SectionHeading({
  children,
  character = '氣',
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-222" data-mp="1o8lwgqk0rsb6">
      <p className="text-xl text-amber-700/70 md:text-2xl" aria-hidden="true" data-id="element-223" data-mp="1o9dsu3lfxu2i">
        {character}
      </p>
      <h2 className="mt-2 text-2xl font-bold leading-tight tracking-tight text-stone-900 md:text-4xl" data-id="element-224" data-mp="2bz84ihu0xcl6">
        {children}
      </h2>
      <span className="mx-auto mt-4 block h-px w-40 bg-stone-300 sm:w-56" aria-hidden="true" data-id="element-225" data-mp="228mvs1kmyroj" />
    </div>;
}